import {KpiName, KPI_NAMES} from '@domain/pom'
import {FormControl, InputLabel, MenuItem, Select} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {ValidationResult} from '../../common/validator/validator.types'
import {FEATURE_NAMESPACE} from '../../consts'

type Props = {
  value?: KpiName
  onChange?: (value?: KpiName) => void
  error?: ValidationResult
  disabled?: boolean
}

export const KpiNameField: React.FC<Props> = ({value, onChange, error, disabled}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <FormControl fullWidth variant="filled" error={Boolean(error)}>
      <InputLabel>{t('actionDialog.kpiName')}</InputLabel>
      <Select
        value={value ?? ''}
        onChange={(e) => onChange?.(e.target.value ? (e.target.value as KpiName) : undefined)}
        disabled={disabled}
        data-test-id="action-kpi-name"
      >
        <MenuItem value="">-</MenuItem>
        {KPI_NAMES.map((option) => (
          <MenuItem key={option} value={option}>
            {t(`kpiName.${option}`)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
